import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Icon} from "semantic-ui-react";
import {Tooltip} from "antd";
import Inquiries from "../../views/Reception/Dashboard/Inquiries/Inquiries";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultFooter extends Component {
  state = {
    isOffline: false,
    isInquiries: false,
  };
  render() {
    return (
      <React.Fragment>
        {
          this.state.isInquiries ?
            <Inquiries closeModal={()=>this.setState({isInquiries: false})}/>:null
        }
        <span><a>Tags</a> &copy; 2023</span>
        {
          this.props.ROLE === "CORPORATE" ?
            <Tooltip placement="topLeft" title="User inquiries">
              <button style={{marginLeft: '15px'}} className={"inquiries-btn"} onClick={()=>this.setState({isInquiries:true})}>User inquiries &nbsp;
                <Icon name={"write square"}/>
              </button>
            </Tooltip>:null
        }

        <span className="ml-auto" style={{fontSize:'13px'}}>Solution partner <a target="_blank" href={"https://ceyentra.com/"} style={{textDecoration:'none',color:'#1f1f1f!important'}}>Ceyentra Technologies</a></span>

      </React.Fragment>
    );
  }
}

DefaultFooter.propTypes = propTypes;
DefaultFooter.defaultProps = defaultProps;

export default DefaultFooter;
